import React, { Fragment } from 'react';
import { connect } from '../../redux/store';
import { PageTitle } from '../shared/PageTitle';
import { PortfolioCard } from '../shared/PortfolioCard';
import {
  EmptyMessage,
  ErrorMessage,
  LoadingMessage,
  C,
} from '@kineticdata/bundle-common';

import image from '../../../assets/images/wheat.jpg';

const CatalogComponent = ({
  init,
  loading,
  errors,
  portfolios,
  appLocation,
}) => {
  return (
    <Fragment>
      <div className="page-container">
        <div className="page-image page-image--sm">
          <img src={image} alt="" />
        </div>
        <div className="page-panel">
          <PageTitle parts={['Service Catalog']} title="Service Catalog" />

          {init &&
            (errors.size > 0 ? (
              <ErrorMessage
                title="The service catalog failed to load."
                message={errors
                  .map(e => e.message)
                  .filter(Boolean)
                  .join('\n')}
              />
            ) : loading ? (
              <LoadingMessage />
            ) : portfolios.size === 0 ? (
              <EmptyMessage title="The service catalog is empty." />
            ) : (
              <div className="cards">
                {portfolios.map(portfolio => (
                  <PortfolioCard
                    key={portfolio.id}
                    portfolio={portfolio}
                    path={`${appLocation}/servicecatalog/portfolios/${
                      portfolio.values[C.FIELD_PORTFOLIO_ID]
                    }`}
                  />
                ))}
              </div>
            ))}
        </div>
      </div>
    </Fragment>
  );
};

const mapStateToProps = (state, props) => {
  return {
    init: state.app.catalog.init,
    loading: !state.app.catalog.init && state.app.catalog.loading,
    errors: state.app.catalog.errors,
    portfolios: state.app.catalog.portfolios,
    services: state.app.catalog.services,
    appLocation: state.app.location,
    layoutSize: state.app.layoutSize,
    isMobile: ['small', 'medium'].includes(state.app.layoutSize),
  };
};

export const Catalog = connect(mapStateToProps)(CatalogComponent);
